import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import { PostSupportersClubsResponse } from './types/post-supporters-clubs.type';

export const postSupportersClubs = async (
    id: number
): Promise<AxiosResponse<PostSupportersClubsResponse>> => {
    const apiUrl = `/account/supporters-clubs/join?id=${id}`;

    const response = await api.post(apiUrl);

    return response;
};
